import { ReactNode } from 'react'

export default function Layout({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) {
  return (
    <main
      className={`mx-auto flex h-dvh max-w-4xl flex-col overflow-y-auto px-8 pt-8 pb-14 ${className}`}
    >
      {children}
    </main>
  )
}
